module.exports = __webpack_public_path__ + "img/ic_feature_coach.33c8a5d7.svg";